import React, { useRef, useEffect } from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, IExtractedProps } from "Common/utils/commonTypes";

export function addListClasses(node: Element): void {
    if (node.tagName === "UL") {
        node.classList.add("tq-list-new");
        node.classList.add("un-list-red-circles");
    }
    for (let i = 0; i < node.children.length; ++i) {
        addListClasses(node.children[i]);
    }
}

export const MoreInfo: React.FC<IComponentProps> = props => {
    const text: React.MutableRefObject<HTMLDivElement> = useRef(null);
    useEffect(() => {
        if (text.current) {
            addListClasses(text.current);
        }
    });

    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["text", "title", "anchorId"]
    });

    return (
        <div
            className="tq-neutral-color-bg-5 un-additional-info-box"
            id={dataProps.anchorId ? dataProps.anchorId : null}
        >
            <h2 className="tq-title tq-secondary-color-3 un-title-red">
                <span
                    className="tq-text-node"
                    dangerouslySetInnerHTML={{
                        __html: xssFilter.process(dataProps.title)
                    }}
                    data-hyperlinks-container={true}
                />
            </h2>
            <div
                dangerouslySetInnerHTML={{
                    __html: xssFilter.process(dataProps.text)
                }}
                ref={text}
                data-hyperlinks-container={true}
            ></div>
        </div>
    );
};

export default webui.connectComponent()(MoreInfo);
